// localhost
// export const httpServer = "http://localhost:8080";

// prodaction
export const httpServer = "https://admin.musictherapy.by";

// herocku
// export const httpServer = "https://musictherapy96.herokuapp.com";
